let email;

const bis_popup = document.querySelector('.bis-popup');
const email_input = document.querySelector('.js-bis-input');
const send_button = document.querySelector('.js-bis-send');
const bis_form = document.querySelector('.js-bis-wrapper');
const bis_sucess = document.querySelector('.js-bis-success');

function validateEmail(email) {
  var pattern =
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return pattern.test(email);
}

function validate() {
  email = email_input.value;
  if (validateEmail(email)) {
    send_button.classList.remove('button--disabled');
  } else {
    send_button.classList.add('button--disabled');
  }
  return false;
}

function debounce(func, delay) {
	let timerId;
	return (...args) => {
		clearTimeout(timerId);
		timerId = setTimeout(() => {
			func.apply(this, args);
		}, delay);
	};
}

function initBackInStockPopup() {
  const open_bis = document.querySelector('.js-bis-open');
  const close_bis = document.querySelector('.js-bis-close');
  if (open_bis) {
    open_bis.addEventListener('click', (e)=> {
      e.preventDefault()
      bis_popup.classList.add('active');
      document.getElementsByTagName('html')[0].classList.add('no_scroll');
      bis_form.style.display = 'block';
      bis_sucess.style.display = 'none';
    })
  }

  if (close_bis) {
    close_bis.addEventListener('click', (e)=> {
      e.stopPropagation();
      bis_popup.classList.remove('active');
      document.getElementsByTagName('html')[0].classList.remove('no_scroll');
    })
  }

  email_input.addEventListener('input', debounce(validate, 200));


  send_button.addEventListener('click', (e) => {
    e.preventDefault()
    
    const subscribe_checkbox = document.querySelector('.js-subscribe');
    if (subscribe_checkbox.checked) {
      subscribe();
      sendBIS();
    } else {
      sendBIS();
    }
  });
}

function sendBIS() {
    const id = document.querySelector('.js-main-variant-selector').value
    // const url = 'https://a.klaviyo.com/onsite/components/back-in-stock/subscribe';
    // let formdata = new FormData();
    //   formdata.append("a", "QaaRJW");
    //   formdata.append("email", `${email}`);
    //   formdata.append("variant", `${id}`);
    //   formdata.append("platform", "shopify");

    // fetch(url, {
    //   method: 'POST',
    //   body: formdata,
    //   redirect: 'follow'
    // }).then(()=> {
     
    // })

    const payload = {
      "data": {
        "type": "back-in-stock-subscription",
        "attributes": {
          "profile": {
            "data": {
                "type": "profile",
                "attributes": {
                    "email": `${email}`,
                }
            }
          },
          "channels": ["EMAIL"],
        },
        "relationships": {
          "variant": {
            "data": {
              "type": "catalog-variant",
              "id": `$shopify:::$default:::${id}`
            }
          }
        }
      }
    }
    
    var requestOptions = {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "revision":"2023-12-15"
        },
        body: JSON.stringify(payload),
    };
    
    fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=QaaRJW",requestOptions)
        .then(result => {console.log(result) 
        bis_form.style.display = 'none';
        bis_sucess.style.display = 'block';
  
        setTimeout(() => {
          bis_popup.classList.remove('active');
          document.getElementsByTagName('html')[0].classList.remove('no_scroll');
        }, 2000);
      }).catch(error => console.log('error', error));
}

async function subscribe() {
  const subscibe_form = document.getElementById('bis_newsletter_signup');
  const data = new URLSearchParams(new FormData(subscibe_form)).toString();

  const responce = await fetch(subscibe_form.action, {
    method: 'POST',
    body: data,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      Accept: 'text/html, */*; q=0.01',
      'X-Requested-With': 'XMLHttpRequest',
    },
  });

  if(responce.status === 200) {
    const result = await responce.text();
  } 
}

document.addEventListener('DOMContentLoaded', ()=> {
  validate()
  initBackInStockPopup()
})